module.exports = __webpack_public_path__ + "img/bg.73755dda.jpg";